import script from "./ViewAllSubManagers.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllSubManagers.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllSubManagers.vue?vue&type=style&index=0&id=ff0e74ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff0e74ca"]])

export default __exports__